/**
 * Orders 4 points into [top-left, top-right, bottom-right, bottom-left].
 * Uses sum (x+y) for TL/BR and difference (y-x) for TR/BL.
 */
export function orderPoints(points) {
  const sorted = [...points];

  const sums = sorted.map((p) => p.x + p.y);
  const diffs = sorted.map((p) => p.y - p.x);

  const tlIndex = sums.indexOf(Math.min(...sums));
  const brIndex = sums.indexOf(Math.max(...sums));
  const trIndex = diffs.indexOf(Math.min(...diffs));
  const blIndex = diffs.indexOf(Math.max(...diffs));

  return [sorted[tlIndex], sorted[trIndex], sorted[brIndex], sorted[blIndex]];
}

export function distance(a, b) {
  return Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
}

export function maxCornerDisplacement(a, b) {
  return Math.max(
    distance(a[0], b[0]),
    distance(a[1], b[1]),
    distance(a[2], b[2]),
    distance(a[3], b[3])
  );
}
